var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _path5, _linearGradient5, _path6, _path7, _linearGradient6, _path8, _linearGradient7, _path9, _path0, _path1, _path10, _path11, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Wastedisposal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "CrBL6BzY21XI4PMDyMpSHa",
    x1: 13.98,
    x2: 13.98,
    y1: 18.359,
    y2: 21.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4943b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2620e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2620e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CrBL6BzY21XI4PMDyMpSHa)",
    d: "M13.98,18c-2.01,0-2.01,0.944-4.02,0.944C9.959,20.359,11.5,20.5,11.5,22h5 c0-1.5,1.5-1.641,1.5-3.056C15.99,18.944,15.99,18,13.98,18z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "CrBL6BzY21XI4PMDyMpSHb",
    x1: 9.874,
    x2: 15.852,
    y1: 19.805,
    y2: 36.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4943b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2620e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2620e"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CrBL6BzY21XI4PMDyMpSHb)",
    d: "M22,31.333C22,35.715,18.409,36,13.98,36s-8.02-0.285-8.02-4.667S9.55,22,13.98,22 S22,26.952,22,31.333z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "CrBL6BzY21XI4PMDyMpSHc",
    x1: 14,
    x2: 14,
    y1: 15.326,
    y2: 24.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a34f27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#8b3817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#802d10"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CrBL6BzY21XI4PMDyMpSHc)",
    d: "M17,23h-6c-0.553,0-1-0.447-1-1s0.447-1,1-1h6c0.553,0,1,0.447,1,1S17.553,23,17,23z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "CrBL6BzY21XI4PMDyMpSHd",
    x1: -7.363,
    x2: 23.477,
    y1: 19.343,
    y2: 37.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a34f27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#8b3817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#802d10"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CrBL6BzY21XI4PMDyMpSHd)",
    d: "M39.5,31c-1.08,0-2.058,0.396-2.833,1.03C36.11,30.834,34.906,30,33.5,30 c-1.05,0-1.982,0.472-2.623,1.205C29.63,29.278,27.466,28,25,28c-2.389,0-4.495,1.198-5.758,3.024C18.692,30.401,17.896,30,17,30 c-1.122,0-2.089,0.624-2.604,1.536C13.767,30.609,12.705,30,11.5,30c-1.499,0-2.768,0.947-3.267,2.271C7.856,32.101,7.441,32,7,32 c-1.657,0-3,1.343-3,3v7h40v-6.5C44,33.015,41.985,31,39.5,31z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#35c1f1",
    d: "M40.759,24.01c0.415-0.101,0.751-0.402,0.897-0.803l0.277-0.762 c0.143-0.394,0.049-0.598-0.238-1.211l-2.22-3.693l-3.297-1.2l-4.074,1.402c-0.614,0.286-0.818,0.381-0.961,0.775l-0.277,0.762 c-0.146,0.401-0.082,0.848,0.171,1.192l0.957,1.303l-0.218,0.599l-1.571,0.383c-0.415,0.101-0.751,0.402-0.897,0.803l-5.002,13.744 c-0.241,0.662,0.1,1.394,0.762,1.635c0,0,0,0,0.001,0l8.391,3.054c0.662,0.241,1.394-0.1,1.635-0.762c0,0,0,0,0-0.001l5.002-13.744 c0.146-0.401,0.082-0.848-0.171-1.192l-0.957-1.303l0.218-0.599L40.759,24.01z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "CrBL6BzY21XI4PMDyMpSHe",
    x1: 31.502,
    x2: 31.502,
    y1: 3882.788,
    y2: 3885.339,
    gradientTransform: "rotate(19.999 11004.25 1969.239)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d61a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364,
    stopColor: "#0e5fa4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#135897"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16528c"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CrBL6BzY21XI4PMDyMpSHe)",
    d: "M39.572,17.745l-3.596-1.309c-0.331-0.121-0.502-0.487-0.381-0.818l0.436-1.199 c0.121-0.331,0.487-0.502,0.818-0.381l3.596,1.309c0.331,0.121,0.502,0.487,0.381,0.818l-0.436,1.199 C40.269,17.695,39.903,17.865,39.572,17.745z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M40.759,24.01c0.415-0.101,0.751-0.402,0.897-0.803l0.203-0.557L31.07,18.723l-0.203,0.557 c-0.146,0.401-0.082,0.848,0.171,1.192l0.957,1.303l-0.218,0.599l-1.571,0.383c-0.415,0.101-0.751,0.402-0.897,0.803l-5.002,13.744 c-0.241,0.662,0.1,1.394,0.762,1.635c0,0,0,0,0.001,0l8.391,3.054c0.662,0.241,1.394-0.1,1.635-0.762c0,0,0,0,0-0.001l5.002-13.744 c0.146-0.401,0.082-0.848-0.171-1.192l-0.957-1.303l0.218-0.599L40.759,24.01z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "CrBL6BzY21XI4PMDyMpSHf",
    x1: 6.397,
    x2: 47.285,
    y1: 29.838,
    y2: 53.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a34f27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#8b3817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#802d10"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CrBL6BzY21XI4PMDyMpSHf)",
    d: "M40.9,37.1c-0.004-0.001-0.007-0.001-0.011-0.002C40.479,35.325,38.898,34,37,34 c-1.607,0-2.983,0.954-3.619,2.321c0,0,0,0-0.001-0.001C32.49,35.5,31.3,35,30,35c-1.8,0-3.38,0.96-4.26,2.39 C25.07,35.42,23.2,34,21,34c-1.49,0-2.83,0.66-3.74,1.69c-0.001,0.001-0.001,0.002-0.002,0.002C16.533,34.671,15.348,34,14,34 c-1.564,0-2.903,0.906-3.561,2.214c-0.003-0.001-0.006-0.003-0.009-0.004c-0.394-0.122-0.81-0.191-1.243-0.207 C6.336,35.902,4,38.393,4,41.245L4,42c0,0.552,0.448,1,1,1h38c0.552,0,1-0.448,1-1v-1C44,39.1,42.68,37.51,40.9,37.1z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "CrBL6BzY21XI4PMDyMpSHg",
    x1: 25.5,
    x2: 25.5,
    y1: -5.658,
    y2: 20.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d6d6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.987,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#454545"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#CrBL6BzY21XI4PMDyMpSHg)",
    d: "M39,11c-0.552,0-1-0.448-1-1c-0.082-1.69-1-3.229-2.447-4.105 c-0.494-0.247-0.694-0.848-0.447-1.342s0.848-0.694,1.342-0.447l0,0c1.504,0.828,2.635,2.2,3.161,3.835 C40.798,6.797,42.353,6.11,44,6c0.552,0,1,0.448,1,1s-0.448,1-1,1c-1.464,0-3.174,1.318-4.219,2.625C39.591,10.862,39.304,11,39,11z M20.895,15.447c0.303-0.606,0.8-1.024,1.437-1.21c0.923-0.267,2.042-0.047,3.154,0.62c0.335,0.202,0.756,0.189,1.077-0.031 c0.322-0.219,0.488-0.605,0.424-0.99c-0.187-1.118,0.034-2.086,0.638-2.798C28.183,10.378,29.049,10,30,10c0.553,0,1-0.447,1-1 s-0.447-1-1-1c-1.54,0-2.963,0.636-3.902,1.745c-0.634,0.749-1.019,1.669-1.136,2.683c-1.102-0.358-2.195-0.4-3.19-0.11 c-1.168,0.34-2.115,1.134-2.666,2.235c-0.247,0.494-0.047,1.095,0.447,1.342C19.696,15.966,19.849,16,19.999,16 C20.366,16,20.719,15.798,20.895,15.447z M7.948,11.316c0.292-0.873,1.202-1.74,2.81-1.347c0.352,0.09,0.729-0.021,0.976-0.29 c0.248-0.268,0.331-0.649,0.215-0.996c-0.208-0.625-0.161-1.336,0.124-1.854c0.239-0.436,0.633-0.725,1.17-0.859 c0.536-0.134,0.862-0.677,0.728-1.212c-0.134-0.536-0.678-0.863-1.212-0.728c-1.085,0.271-1.928,0.906-2.438,1.837 C9.99,6.466,9.821,7.165,9.82,7.877c-1.744,0.067-3.202,1.105-3.769,2.807c-0.175,0.524,0.108,1.091,0.632,1.265 C6.789,11.983,6.896,12,7,12C7.419,12,7.809,11.735,7.948,11.316z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M41.69,36.29C40.98,34.33,39.13,33,37,33c-1.52,0-2.95,0.71-3.89,1.87C32.18,34.3,31.11,34,30,34 c-1.53,0-2.97,0.57-4.06,1.58C24.84,33.99,23.01,33,21,33c-1.34,0-2.64,0.45-3.68,1.27C16.41,33.46,15.23,33,14,33 c-1.62,0-3.11,0.78-4.04,2.08C9.72,35.04,9.47,35.01,9.22,35h-0.2c-1.61,0-3.13,0.67-4.28,1.89C4.46,37.18,4.22,37.5,4,37.84v3.41 C4,38.45,6.25,36,9.02,36h0.17c0.43,0.02,0.85,0.09,1.24,0.21h0.01c0.66-1.3,2-2.21,3.56-2.21c1.35,0,2.53,0.67,3.26,1.69 C18.17,34.66,19.51,34,21,34c2.2,0,4.07,1.42,4.74,3.39C26.62,35.96,28.2,35,30,35c1.3,0,2.49,0.5,3.38,1.32 c0.32-0.68,0.82-1.26,1.45-1.67C35.45,34.24,36.2,34,37,34c1.9,0,3.48,1.33,3.89,3.1h0.01c1.78,0.41,3.1,2,3.1,3.9v-3.02 C43.43,37.22,42.63,36.62,41.69,36.29z",
    opacity: 0.05
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3,36.69C40.72,34.8,39,33.5,37,33.5c-1.52,0-2.94,0.79-3.77,2.05C32.3,34.87,31.17,34.5,30,34.5 c-1.62,0-3.11,0.69-4.15,1.9c-0.95-1.77-2.8-2.9-4.85-2.9c-1.38,0-2.7,0.52-3.71,1.44c-0.84-0.91-2.04-1.44-3.29-1.44 c-1.56,0-2.99,0.81-3.81,2.13c-0.31-0.07-0.65-0.11-0.99-0.13H9.02c-1.47,0-2.86,0.61-3.91,1.73C4.64,37.72,4.27,38.3,4,38.92 v2.33C4,38.45,6.25,36,9.02,36h0.17c0.43,0.02,0.85,0.09,1.24,0.21h0.01c0.66-1.3,2-2.21,3.56-2.21c1.35,0,2.53,0.67,3.26,1.69 C18.17,34.66,19.51,34,21,34c2.2,0,4.07,1.42,4.74,3.39C26.62,35.96,28.2,35,30,35c1.3,0,2.49,0.5,3.38,1.32 c0.32-0.68,0.82-1.26,1.45-1.67C35.45,34.24,36.2,34,37,34c1.9,0,3.48,1.33,3.89,3.1h0.01c1.78,0.41,3.1,2,3.1,3.9v-2.08 C43.45,37.87,42.49,37.05,41.3,36.69z",
    opacity: 0.07
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.49,28.38c-0.05-0.16-0.11-0.32-0.17-0.48c-0.83,0.43-1.58,1-2.22,1.7C18.47,29.21,17.75,29,17,29 c-0.99,0-1.93,0.37-2.65,1.02C13.56,29.37,12.55,29,11.5,29c-1.54,0-2.96,0.8-3.77,2.07C7.49,31.02,7.24,31,7,31 c-0.36,0-0.71,0.05-1.04,0.14v0.19c0,0.11,0,0.22,0.01,0.33c0.01,0.18,0.02,0.36,0.04,0.52C6.32,32.06,6.65,32,7,32 c0.44,0,0.86,0.1,1.23,0.27C8.73,30.95,10,30,11.5,30c1.2,0,2.27,0.61,2.9,1.54C14.91,30.62,15.88,30,17,30 c0.9,0,1.69,0.4,2.24,1.02c0.62-0.89,1.44-1.63,2.41-2.16C21.6,28.7,21.55,28.54,21.49,28.38z",
    opacity: 0.05
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.49,28.38c-0.88,0.46-1.67,1.1-2.31,1.9c-0.62-0.5-1.39-0.78-2.18-0.78c-1.02,0-1.97,0.45-2.63,1.21 c-0.75-0.77-1.78-1.21-2.87-1.21c-1.48,0-2.85,0.84-3.53,2.14C7.65,31.55,7.33,31.5,7,31.5c-0.36,0-0.7,0.05-1.03,0.16 c0.01,0.18,0.02,0.36,0.04,0.52C6.32,32.06,6.65,32,7,32c0.44,0,0.86,0.1,1.23,0.27C8.73,30.95,10,30,11.5,30 c1.2,0,2.27,0.61,2.9,1.54C14.91,30.62,15.88,30,17,30c0.9,0,1.69,0.4,2.24,1.02c0.62-0.89,1.44-1.63,2.41-2.16 C21.6,28.7,21.55,28.54,21.49,28.38z",
    opacity: 0.07
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 39,
    r: 1,
    fill: "#d4943b"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 40,
    r: 1,
    fill: "#d4943b"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 38,
    r: 1,
    fill: "#d4943b"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 40,
    r: 1,
    fill: "#d4943b"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 38,
    r: 1,
    fill: "#d4943b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Wastedisposal);
export default __webpack_public_path__ + "static/media/icons8-wastedisposal.7601cb29602ee7c65cadb0cc239a0bea.svg";
export { ForwardRef as ReactComponent };